import { Stack } from "@mantine/core"

const SymbolChart = ({ symbol }) => {
	const ticker = `COINBASE:${symbol.code.toUpperCase()}`;
	const tradingViewSrc = `https://s.tradingview.com/widgetembed/?symbol=${encodeURIComponent(ticker)}&interval=D&timezone=Etc%2FUTC&locale=in`;

	return (
		<Stack>
			<iframe
				title={`TradingView-${ticker}`}
				src={tradingViewSrc}
				width="800"
				height="520"
				frameBorder="0"
				allowTransparency={true}
				scrolling="no"
			/>
		</Stack>

	)
}

export default SymbolChart;